import * as React from "react";
const SvgFiRrFlute = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flute_svg__a)">
      <path
        fill="#062147"
        d="m23.123 1.335-.457-.458A3.006 3.006 0 0 0 19.04.405c-.529.307-1.354.695-2.277.803a3.4 3.4 0 0 0-2.01.969c-.854.853-11.84 11.92-13.58 13.661a3.97 3.97 0 0 0-1.172 2.827c0 1.068.416 2.073 1.172 2.828l1.414 1.414a3.99 3.99 0 0 0 2.828 1.17 4 4 0 0 0 2.829-1.17l.002-.002L21.819 9.251c.54-.54.886-1.255.974-2.015.085-.73.362-1.518.802-2.276a3 3 0 0 0-.472-3.625m-3.081.8a1 1 0 0 1 1.21.156l.457.458a1 1 0 0 1 .155 1.208 8.5 8.5 0 0 0-.792 1.826l-2.856-2.856a8.6 8.6 0 0 0 1.826-.792M6.828 21.495a2.004 2.004 0 0 1-2.827 0L2.587 20.08a1.99 1.99 0 0 1-.586-1.414c0-.534.208-1.036.586-1.414C4.329 15.51 15.225 4.534 16.109 3.65l4.243 4.243zM16 9.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 16 9.5M12.5 13A1.5 1.5 0 1 1 9.499 13 1.5 1.5 0 0 1 12.5 13M9 16.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 9 16.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flute_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlute;
